import { CommandDeparture, CommandFlag, CostBasis, MarginBand } from './types';

export const marginBandLabels: Record<MarginBand, string> = {
  loss: 'Loss',
  very_thin: 'Very Thin',
  thin: 'Thin',
  below_target: 'Moderate',
  on_track: 'On Track',
  healthy: 'Healthy',
  no_sale: 'No Sale',
};
export const marginBandRanges: Record<MarginBand, string> = {
  loss: 'below 0%',
  very_thin: '0 to 5%',
  thin: '5 to 10%',
  below_target: '10 to 15%',
  on_track: '15 to 20%',
  healthy: '20% or more',
  no_sale: 'Expected to finish with no travellers',
};
export function worstMarginDeparture(rows: Array<CommandDeparture>, basis: CostBasis): CommandDeparture | undefined {
  const bands = Object.keys(marginBandLabels);
  const live = rows.filter((d) => d.days_to_handback >= 0 && ((d.on_sale ?? d.state === 'On sale') || d.pax > 0));
  return [...(live.length ? live : rows)].sort((a, b) => {
    const rank = (d: CommandDeparture) =>
      bands.indexOf(medianBand(d, basis)) < 0 ? 7 : bands.indexOf(medianBand(d, basis));
    const actionRank = (d: CommandDeparture) =>
      ({ red: 0, amber: 1, empty: 2, green: 3, unavailable: 4, 'handed back': 5 })[actionFlag(d, basis)] ?? 6;
    return actionRank(a) - actionRank(b) || rank(a) - rank(b);
  })[0];
}

/** Use the predicted margin quantile even when reading an older cached snapshot. */
export function medianBand(d: CommandDeparture, basis: CostBasis): MarginBand | null {
  const data = d[`margin_bands_${basis}`];
  const rate = d.days_to_handback < 0 ? d[`margin_pct_${basis}`] : data?.pred_margin_pct_p50;
  if (d.days_to_handback < 0 ? !(d.ttv > 0 && d[`cost_${basis}`] > 0) : !data?.margin_available) return null;
  if (rate == null) return 'no_sale';
  return rate < 0
    ? 'loss'
    : rate < 0.05
      ? 'very_thin'
      : rate < 0.1
        ? 'thin'
        : rate < 0.15
          ? 'below_target'
          : rate < 0.2
            ? 'on_track'
            : 'healthy';
}
/** The service's action for the departure. Business rules live in svc-reporting; the page only renders them. */
export function actionFlag(d: CommandDeparture, basis: CostBasis): CommandFlag {
  return d[`flag_${basis}`];
}
